module.exports = __webpack_public_path__ + "img/bk.d07d571e.jpg";